if (!customElements.get('additional-info')) {
  class AdditionalInformation extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.innerHTML = '';
      document.querySelectorAll('.additional-info').forEach((info) => {
        info.removeAttribute('hidden');
        this.append(info);
      });
    }
  }

  customElements.define('additional-info', AdditionalInformation);
}